<div class="card-padding">
    <mat-card>                      
        <mat-card-header>
            <div mat-card-avatar style="background-size: cover;" [ngStyle]="{ 'background-image': 'url(' + professor.displayInformation.avatarUrl + ')'}"></div>
            <mat-card-title>{{professor.personalInformation.name}}</mat-card-title>
        </mat-card-header>
    </mat-card>
</div>
